import { FC } from 'react';
import ScanPageLeft from './left';
import LeftFormItem from './formItem';
import LeftCustom from './custom';
import {
  ScanPageLeftProps,
  ScanPageLeftFormItemProps,
  ScanPageLeftCustomProps,
} from '../../interface';

export type IScanPageLeftComponent = FC<ScanPageLeftProps> & {
  FormItem: FC<ScanPageLeftFormItemProps>;
  Custom: FC<ScanPageLeftCustomProps>;
};

const TransScanPageLeft = ScanPageLeft as IScanPageLeftComponent;
TransScanPageLeft.FormItem = LeftFormItem;
TransScanPageLeft.Custom = LeftCustom;

export default TransScanPageLeft;